export const environment = {
    API_BASE: 'https://hom.api.rapidocs.pro/api/v1/',
    PLATFORM_BASE: 'https://hom.rapidocs.pro/#/',
    GOOGLE_WEB_CLIENT_ID:
        '708381046360-4pl08jrslmobif4n3ln0jsenigrp3roh.apps.googleusercontent.com',

    // Firebase — usado APENAS pelo Sign in with Apple (o backend valida o ID token
    // do Firebase em `POST auth/login-apple`). Projeto: magic-report-62bb3, o mesmo
    // do app Flutter. `apiKey`/`appId` vêm do app **Web** registrado no console do
    // Firebase (Configurações do projeto → Seus apps → Web) — preencher antes de usar.
    FIREBASE: {
        apiKey: 'AIzaSyCqtjR0S_za998zlpzMJiph-blK9npAWt0',
        authDomain: 'magic-report-62bb3.firebaseapp.com',
        projectId: 'magic-report-62bb3',
        appId: '1:708381046360:web:61c7406bf021c27014bc2d',
    },

    // Pusher
    PUSHER_KEY: '938f7fac13936116ecb2',

    // LIMITES
    LIMITES: {
        MAX_CHARACTERS: 5000,
    },

    // Default font family
    DEFAULT_FONT_FAMILY: 'Roboto',

    // "Editar com IA" (docs/EDITOR-CHAT-IA.md).
    // AI_EDIT_REQUIRE_FLAG: exige a feature flag `ai_edit_mode` para mostrar o modo. Desligado
    // (todo mundo vê) enquanto a feature é testada até hom; em produção continua exigida.
    // AI_EDIT_MOCK: um mock local responde o `document/ai-edit` com 202 e simula os eventos
    // do Pusher, para mexer na interface sem a API. Desligado: a API real já existe.
    AI_EDIT_REQUIRE_FLAG: false,
    AI_EDIT_MOCK: false,

    // Code verification inside APP
};
